import { render, staticRenderFns } from "./ConsultantAdmin.vue?vue&type=template&id=7fc1cf0f&"
import script from "./ConsultantAdmin.vue?vue&type=script&lang=js&"
export * from "./ConsultantAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports